export const lang = {
  locale: 'English',
  toolbar: {
    Login: 'Login',
    Logout: 'Logout',
    Home: 'Home',
    Profile: 'Profile',
    Register: 'Register',
    Recovery: 'Recovery',
    PasswordChange: 'Change Password',
    UserCenter: 'User Center',
    Cancel: 'Cancel',
    OK: 'OK',
    Submit: 'Submit',
    Save: 'Local Save',
    Confirm: 'Confirm',
    Columns: 'Display Columns',
    AddMeta: 'Add Meta Data',
    AddParagraph: 'Add Paragraph',
    AddPart: 'Add Part',
    Add: 'Add',
    Delete: 'Delete',
    Edit: 'Edit',
    Modify: 'Modify',
    Preview: 'Preview',
    Details: 'Details',
    Search: 'Search',
    Select: 'Select',
    Reset: 'Reset',
    About: 'About',
    Console: 'Console',
    TryIT: 'Try It',
    Chat: 'Chat',
    Release: 'Release',
    Restore: 'Restore'
  },
  words: {
    newpassword: 'New Password',
    password: 'Input New Password',
    password2: 'Input New Password again',
    accountconfirm: 'Account Confirm',
    accountconfirmpoint: 'Check the Account By Email',
    otherlogin: 'Other Login',
    member: 'Member list',
    stamp: 'Stamp usage report',
    coupon: 'Coupon usage report',
    stampcode: 'Issue stamp code',
    coupondef: 'Manage coupon defination',
    nexttitle: 'SCWS Management Console',
    nextsubtitle: 'Next-Gen Semcent Cloud Web Service Management Console',
    nextdescription: "<ul class='list-unstyled'><li>Localization</li><li>Simplify the process</li><li></li><li>Enunciate your intentions clearly so that the users can quickly understand and make decisions</li><li>Functions:<ul><li>Card Member</li><li>Coupon</li><li>Stamp</li></ul></li><li>SemcentCloud Web Service manangement</li></ul>",
    cms: 'Contents Management System',
    lms: 'Learning Management System',
    ec: 'Shopping Mall',
    crm: 'Customer Management System'
  },
  dict: {
    total: 'Total',
    subtotal: 'SubTotal',
    addr: 'Address',
    init: 'Init',
    inc: 'Inc',
    rate: 'Rate',
    amount: 'Amount',
    way: 'Way',
    pfromto: 'Price Region',
    qfromto: 'Quatity Region',
    initdate: 'Init Date',
    initstock: 'Init Stock',
    stockavailable: 'Available Stock',
    itemcd: 'Item Code',
    titleshort: 'Short Name',
    colornm: 'Color',
    sizenm: 'Size',
    unit: 'Unit',
    iprice: 'InPrice',
    oprice: 'OutPrice',
    dprice: 'DisplayPrice',
    spec: 'Spec',
    taxtype: 'Tax Type',
    taxrate: 'Tax Rate',
    axb: 'axb',
    woc: 'woc',
    province: 'Province',
    city: 'City',
    contactaddr: 'Address',
    contactmobile: 'Mobile',
    contactname: 'Contact',
    dashboard: "Dashboard",
    paragraph: "Paragraph",
    showGallery: "Show Gallery",
    additional: "Additional",
    result: "Result",
    autoJudge: "Auto Judge",
    username: "User Name",
    password: "Password",
    contact: "Contact",
    history: "History",
    name: "Name",
    order: "Order",
    options: "Options",
    questiontype: "Question Type",
    answer: "Answer",
    subject: "Subject",
    quantity: "Quantity",
    email: "Email",
    telephone: "Telephone",
    mobile: "Mobile",
    account: "Account",
    estimate: "Estimate",
    actual: "Actual",
    fee: "Fee",
    score: "Score",
    judge: "Judge",
    correct: "Correct Answer",
    totalScore: "Total Score",
    passScore: "Pass Score",
    updator: "Updator",
    date: "Date",
    reservedate: "Reserve Date",
    createdate: "Create Date",
    updatedate: "Update Date",
    timecycle: "Cycle",
    timestart: "Start Time",
    timeend: "Finish Time",
    timestep: "Step",
    timesteplimit: "Limit",
    datetrans: "Trading Date",
    datestart: "Start Date",
    dateend: "End Date",
    datefinish: "Finish Date",
    dateissued: "Issued Date",
    dateused: "Used Date",
    expire: "Expire",
    status: "Status",
    sex: "Sex",
    cardid: "Card ID",
    title: "Title",
    id: "ID",
    block: "Block",
    generate: "Generate",
    template: "Template",
    codetype: "Code Type",
    condition: "Condition",
    parameter: "Parameter",
    return: "Return",
    datatype: "Data Type",
    from: "From",
    to: "To",
    subscript: "Subscript",
    details: "Details",
    stampid: "Stamp ID",
    gallary: "Gallary",
    text: "Text",
    subtitle: "Sub Title",
    body: "Body",
    summary: "Summary",
    tags: "Tags",
    preface: "Preface",
    category: "Category",
    dictionary: "Dictionary",
    memo: "Memo",
    code: "Code",
    value: "Value",
    cname: "Chinese Name",
    jname: "Japanese Name",
    ename: "English Name",
    kbn: "Type",
    ord: "Order",
    pid: "ParentID",
    lv: "Level",
    target: "Target",
    type: "Type",
    supervisor: "Supervisor",
    invite: "User Invite",
    router: "Router",
    cost: "Cost",
    costest: "Estimate Cost",
    costact: "Actual Cost",
    comment: "Comment",
    staff: "Staff",
    staffto: "Assign to",
    priority: "Priority",
    notetag: "Note Tag",
    flowtype: "Flow Type",
    career: "Career",
    project: "Project",
    auth_group: "Permission",
    auth_list: "List",
    auth_view: "View",
    auth_add: "Add",
    auth_edit: "Edit",
    auth_del: "Delete",
    auth_preview: "Preview",
    auth_details: "Details",
    auth_import: "Import",
    auth_export: "Export",
    auth_setup: "Setup"
  },
  msg: {
    toRecovery: 'Forgot Password?',
    toLogin: 'Already have an account?',
    toRegister: 'Not yet have an account?',
    toLogout: 'Continue to Logout?',
    toPreview: 'Continue to Preview?',
    toDelete: 'Continue to Delete?',
    toContinue: 'Continue to Operate?',
    toOtherLogin: 'Already Have an Account in cloud.semcent.com?',
    toRestore: 'Restore from saved data?'
  },
  datatable: {
    info: 'Showing _PAGE_ of _PAGES_ pages, Total _MAX_ entries',
    infoEmpty: 'No Data'
  },
  error: {
    serverError: 'Server Error。Please contact to System Manager。{error}',
    serverNormal: 'Server Normal',
    notLtnM: 'Not Allowed To Larger than {n}M!',
    notAllowedFmt: 'Selected File Is Not Picture.',
    invalid: '{str} is invalid',
    required: '{str} required',
    notExistAccount: 'account is not exist',
    notAllowed: 'not allowed to delete or modify because of record is {str}',
    failed: 'Failed To {str}',
    failedLogin: 'wrong password',
    failedRequest: 'request failed: {err}'
  },
  info: {
    succeedRegister: 'Succeed to Register.\nRedirect to Login Page',
    succeedRegisterDup: 'Account is exist Already.\nRedirect to Login Page',
    succeedToLogin: 'succeed to login',
    succeedRequst: 'request successfully',
    succeedInsert: 'inserted successfully',
    succeedUpdate: 'updated successfully',
    succeedDelete: 'deleted successfully',
    succeedSave: 'saved successfully'
  },
  notice: {
    updatePost: '[{createdate}] {id}: <span class="text-info">{title}</span>は更新されました。',
    createReserve: '[{createdate}] 予約が入ってきました。',
    updateReserve: '[{createdate}] 予約番号:{id}は{status}に変更しました。',
    addStamp: '[{createdate}] {custname}様はスキャンでスタンプを受け取りました。stampid:{stampid}',
    addStampByCode: '[{createdate}] {custname}番号入力でスタンプを受け取りました。stampid:{stampid}'
  },
  title: {
    style: "Style",
    activity: "Activity",
    menu: 'Menu',
    ec: 'Sales Management',
    depot: 'Depot',
    supplier: 'Supplier',
    item: 'Item',
    stock: 'Stock',
    discount: 'Discount',
    freight: 'Freight',
    order: 'Order',
    member: 'Member',
    coupon: 'Coupon',
    mntcoupon: 'Coupon Maintenance',
    stamp: 'Stamp',
    stampcode: 'Stamp Code',
    content: 'Content',
    bucket: 'Bucket',
    post: 'Post',
    groupware: 'Groupware',
    message: 'Message',
    report: 'Report',
    notice: 'Notice',
    todo: 'TODO',
    note: 'Note',
    resource: 'Resource',
    reserve: 'Reserve',
    schedule: 'Schedule',
    calendar: 'Calendar',
    crm: 'CRM',
    lms: 'LMS',
    test: 'Test',
    template: 'Template',
    construct: 'Construct',
    question: 'Question',
    examresult: 'Exam Result',
    customer: 'Customer',
    contact: 'Contact',
    case: 'Case',
    record: 'Record',
    flow: 'Flow',
    faq: 'Faq System',
    faqreply: 'Faq Reply',
    consult: 'Consult',
    document: 'Document',
    solution: 'Solution',
    product: 'Product',
    setting: 'Setting',
    information: 'Information',
    role: 'Role',
    roletarget: 'Role Target Relation',
    roleperm: 'Role Permission Relation',
    perm: 'Permission',
    org: 'Organization',
    pos: 'Position',
    grp: 'Group',
    user: 'User',
    grant: 'Grant',
    exam: "Examination"
  },
  faq: {
    msgWelcome: '{0} Entered Faq System.'
  },
  chat: {
    start: 'Start',
    send: 'Send',
    sendpromote: 'Please Input your Message',
    sayto: 'I Replied to {0}',
    say: '{0} said'
  }
}
